enum ActionTypes {
    SAVE_ROUTER_HISTORY = "SAVE_ROUTER_HISTORY",
    UPDATE_NETWORK_STATE = "UPDATE_NETWORK_STATE",
}

export default ActionTypes;
